import React from "react";
import PeriodicTableElements from "./PeriodicTableElements";
import TabList from "./TabList.js";
import { ThemeProvider } from "styled-components";
import themes from "utils/themes";

const MaterialContent = props => (
  <div className="hero-body">
    <div className="container">
      <div className="notification is-dark hero is-bold">
        <TabList {...props} />
        <div className="columns">
          <div className="column is-6">
            <h2 className="title is-3">{props.name}</h2>
            {props.subName && (
              <h3 className="subtitle is-5">{props.subName}</h3>
            )}
            <p>{props.description}</p>
          </div>
          <div className="column is-5 is-offset-1">
            <p className="heading">Chemical Makeup</p>
            <ThemeProvider theme={themes.brand}>
              <PeriodicTableElements {...props} />
            </ThemeProvider>
          </div>
        </div>
        <br />
      </div>
    </div>
  </div>
);

export default MaterialContent;



// WEBPACK FOOTER //
// ./src/pages/Materials/MaterialComponent/MaterialContent.js